var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(-0.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(0.239)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "school_5_",
    "data-name": "school (5)",
    transform: "translate(2.737 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M295.607,7.808V6c0-1.56-1.087-3.716-2.014-5.271a1.5,1.5,0,0,0-2.579,0C290.087,2.289,289,4.444,289,6v1.8l3.3,1.3Z",
    transform: "translate(-260.07 0)",
    fill: "#f89580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M163.607,7.82v-1.8c0-1.56-1.087-3.715-2.013-5.27a1.5,1.5,0,0,0-2.579,0C158.087,2.3,157,4.456,157,6.016v1.8l3.3,1.3Z",
    transform: "translate(-141.284 -0.012)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M97.607,6.016c0-1.56-1.087-3.715-2.013-5.27a1.5,1.5,0,0,0-2.579,0C92.087,2.3,91,4.456,91,6.016v1.8l3.3,1.3,3.3-1.3Z",
    transform: "translate(-81.891 -0.012)",
    fill: "#e30a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M51.252,125.18v6.206a1.5,1.5,0,0,1-1.5,1.5H1.5a1.5,1.5,0,0,1-1.5-1.5V125.18a1.5,1.5,0,0,1,1.031-1.426l9.109-3H41.112l9.109,3A1.5,1.5,0,0,1,51.252,125.18Z",
    transform: "translate(0 -108.663)",
    fill: "#613d5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M281.626,125.18v6.206a1.5,1.5,0,0,1-1.5,1.5H256V120.75h15.486l9.109,3A1.5,1.5,0,0,1,281.626,125.18Z",
    transform: "translate(-230.374 -108.663)",
    fill: "#4b2746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M361.607,7.82v-1.8c0-1.56-1.087-3.715-2.013-5.27a1.5,1.5,0,0,0-2.579,0C356.087,2.3,355,4.456,355,6.016v1.8l3.3,1.051Z",
    transform: "translate(-319.464 -0.012)",
    fill: "#5ab267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M282.7,78l-.7,7.307.7,9.91h6.607l1.1-9.91L289.307,78Z",
    transform: "translate(-253.771 -70.192)",
    fill: "#ffbfab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M355,78h6.607V95.218H355Z",
    transform: "translate(-319.464 -70.192)",
    fill: "#97de3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M229.607,6v1.8l-3.3,1.3-3.3-1.3V6c0-1.56,1.086-3.716,2.013-5.27A1.5,1.5,0,0,1,226.3,0h0a1.5,1.5,0,0,1,1.289.733C228.52,2.287,229.607,4.444,229.607,6Z",
    transform: "translate(-200.677 0)",
    fill: "#3aaaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M259.3,6v1.8l-3.3,1.3V0a1.5,1.5,0,0,1,1.289.733C258.216,2.287,259.3,4.444,259.3,6Z",
    transform: "translate(-230.374 0)",
    fill: "#4895ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M148.9,78l-.9,8.058.9,9.159h6.607l1-9.159-1-8.058Z",
    transform: "translate(-133.185 -70.192)",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M223,78h6.607V95.218H223Z",
    transform: "translate(-200.677 -70.192)",
    fill: "#7ed8f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M256,78h3.3V95.218H256Z",
    transform: "translate(-230.374 -70.192)",
    fill: "#3aaaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M91,78h6.607V95.218H91Z",
    transform: "translate(-81.891 -70.192)",
    fill: "#ff435b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M51.252,227v27.028a1.5,1.5,0,0,1-1.5,1.5H1.5a1.5,1.5,0,0,1-1.5-1.5V227Z",
    transform: "translate(0 -204.277)",
    fill: "#f0f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M281.626,227v27.028a1.5,1.5,0,0,1-1.5,1.5H256V227Z",
    transform: "translate(-230.374 -204.277)",
    fill: "#dfe7f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M282.7,302l-.7,5.906.7,6.106h6.607l1-6.106-1-5.906Z",
    transform: "translate(-253.771 -271.769)",
    fill: "#ffbfab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M355,302v12.012h5.105a1.5,1.5,0,0,0,1.5-1.5V303.5a1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(-319.464 -271.769)",
    fill: "#97de3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M148,302l-1,6.006,1,6.006h6.607l1.1-6.006-1.1-6.006Z",
    transform: "translate(-132.285 -271.769)",
    fill: "#fabe2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M223,302h6.607v12.012H223Z",
    transform: "translate(-200.677 -271.769)",
    fill: "#7ed8f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M256,302h3.3v12.012H256Z",
    transform: "translate(-230.374 -271.769)",
    fill: "#3aaaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M92.5,302a1.5,1.5,0,0,0-1.5,1.5v9.009a1.5,1.5,0,0,0,1.5,1.5h5.105V302Z",
    transform: "translate(-81.891 -271.769)",
    fill: "#ff435b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE4);
export default __webpack_public_path__ + "static/media/e4.3da293addee96aea671a41e9828b9ad6.svg";
export { ForwardRef as ReactComponent };